var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0 bg-gray-100"},[_c('div',{staticClass:"min-h-screen p-6 bg-white shadow"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }